<script>
import PayoutListDetails from '@/modules/checkin-facility/pages/dashboard/visitor-payment/payout/arbitrage/payoutListDetails';
import PdfViewer from "@/modules/checkin-facility/pages/dashboard/components/PdfViewer.vue";
import formatters from '@/mixins/formatters.js';

export default {
  name: 'PayoutTransactionListTab',
  mixins: [formatters],
  components: { PayoutListDetails, PdfViewer },
  data() {
    return {
      payoutListCsvFile: null,
      payoutListCsvFileName: '',
      payoutTransactionCsvFile: null,
      payoutTransactionCsvFileName: '',
      isUploading: false,
      alert: { show: false, variant: 'success', message: '' },
      isSubmitted: false,
      listOfPayoutDatas: [],
      payoutHeaderIds: [],
      invoice: { src: '' },
      hasUnsavedChanges: true,
    };
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    this.payoutHeaderIds = JSON.parse(localStorage.getItem('ids')) || [];
    this.deletePayoutBatch();
    localStorage.removeItem('ids');
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  methods: {
    handleBeforeUnload(event) {
      if (this.hasUnsavedChanges && this.isSubmitted) {
        event.preventDefault();
        event.returnValue = '';
        const payoutHeaderIds = JSON.parse(localStorage.getItem('ids')) || [];
        if (payoutHeaderIds.length === 0) localStorage.setItem('ids', JSON.stringify(this.payoutHeaderIds));
      }
    },
    processPayoutListBatch(event) {
      const file = event.target.files[0];
      this.payoutListCsvFileName = file ? file.name : '';
      this.payoutListCsvFile = file || null;
    },
    processPayoutTransactionBatch(event) {
      const file = event.target.files[0];
      this.payoutTransactionCsvFileName = file ? file.name : '';
      this.payoutTransactionCsvFile = file || null;
    },
    async submitPayoutBatch() {
      this.isUploading = true;
      if (!this.payoutListCsvFile || !this.payoutTransactionCsvFile) {
        this.showAlert('danger', this.$t('admin_page.payout_form.please_select_files_alert'));
        return;
      }
      const formData = new FormData();
      formData.append('payoutListCsvFile', this.payoutListCsvFile);
      formData.append('payoutTransactionListCsvFile', this.payoutTransactionCsvFile);
      try {
        const response = await this.$lionheart.post('/v2/batch-payout-upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        if (response.status === 200) {
          this.payoutHeaderIds = response.data.payout_header_ids;
          localStorage.setItem('ids', JSON.stringify(this.payoutHeaderIds));
          this.showAlert('success', this.$t('admin_page.payout_batch_index.success_uploading_alert'));
          this.payoutListCsvFile = null;
          this.payoutTransactionCsvFile = null;
          if (this.$refs.payoutListRef) this.$refs.payoutListRef.value = null;
          if (this.$refs.payoutTransactionRef) this.$refs.payoutTransactionRef.value = null;
          this.isUploading = false;
          this.isSubmitted = true;
        } else {
          this.showAlert('danger', this.$t('admin_page.payout_batch_index.error_on_format_alert'));
          this.isUploading = false;
        }
      } catch (error) {
        console.error('Error creating payout batch:', error);
        this.isUploading = false;
        this.showAlert('danger', this.$t('admin_page.payout_batch_index.error_on_format_alert'));
      }
    },
    async deletePayoutBatch() {
      if (this.payoutHeaderIds.length === 0) return;
      const response = await this.$lionheart.delete('/v2/remove-batch-payout', { params: { payout_header_ids: this.payoutHeaderIds } });
      if (response.status === 200) {
        this.payoutListCsvFileName = '';
        this.payoutTransactionCsvFileName = '';
        this.isSubmitted = false;
        this.listOfPayoutDatas = [];
        this.payoutHeaderIds = [];
      }
    },
    async loadPayoutListData() {
      const response = await this.$lionheart.get('/v2/payout-list-arbitrage-with-facility', { params: { payout_header_ids: this.payoutHeaderIds } });
      if (response.status !== 200) {
        this.showAlert('danger', this.$t('admin_page.payout_batch_index.error_retrieving_alert'));
        return;
      }
      this.listOfPayoutDatas = response.data.listOfPayoutDatas;
    },
   //  async previewInvoice(payoutHeaderId) {
   //    const invoice = await this.$lionheart.get(`/v2/payout-invoice/base64/${payoutHeaderId}`);
   //    if (invoice.data) {
   //      this.invoice.src = invoice.data.data_uri;
   //      setTimeout(() => this.$bvModal.show('modal-pdf-viewer'), 300);
   //    }
   //  },
    async getPayoutTransactionListData(payoutHeaderId) {
      const response = await this.$lionheart.get('/v2/payout-transaction-list-arbitrage', { params: { payout_header_id: payoutHeaderId } });
      if (response.status === 200) {
        this.$refs.payoutListDetails && this.$refs.payoutListDetails.view(response.data.payoutTransactionListDatas, false);
      } else {
        this.showAlert('danger', this.$t('admin_page.payout_batch_index.error_retrieving_alert'));
      }
    },
    async confirmPayoutBatch() {
      const response = await this.$lionheart.post('/v2/confirm-batch-payout', { payout_header_ids: this.payoutHeaderIds });
      if (response.status === 200) {
        this.showAlert('success', this.$t('admin_page.payout_batch_index.confirm_success_alert'));
        this.isSubmitted = false;
        this.listOfPayoutDatas = [];
        this.payoutHeaderIds = [];
        this.payoutListCsvFileName = '';
        this.payoutTransactionCsvFileName = '';
        localStorage.removeItem('ids');
        this.$router.push({ name: 'checkin-admin-payout-list-arbitrage' });
      } else {
        this.showAlert('danger', this.$t('admin_page.payout_batch_index.error_confirming_alert'));
      }
    },
    showAlert(variant = 'success', message) {
      this.alert = { show: true, variant, message };
      setTimeout(() => { this.alert.show = false; }, 3000);
    },
    computeTotalAndVat(total, vat) {
      return this.formatNumber(Number(total) + Number(vat));
    },
  }
};
</script>

<template>
  <div class="row">
    <div class="col">
      <div class="d-flex justify-content-center mt-4">
        <div style="width: 500px;">
          <form @submit.prevent="submitPayoutBatch" v-if="listOfPayoutDatas.length == 0">
            <b-form-group id="fieldset-horizontal" label-cols-sm="4" label-cols-lg="3" content-cols-lg="9" :label="$t('admin_page.payout_batch_index.payout_list_label')" :description="payoutListCsvFileName" label-for="input-horizontal">
              <input @change="processPayoutListBatch($event)" type="file" ref="payoutListRef" class="form-control" accept=".csv, text/csv" style="display: none;" />
              <b-button @click="$refs.payoutListRef.click()" variant="success" class="btn-md" :disabled="isSubmitted">{{ $t('admin_page.payout_batch_index.payout_upload_button_text') }}</b-button>
            </b-form-group>
            <b-form-group id="fieldset-horizontal" label-cols-sm="4" label-cols-lg="3" content-cols-lg="9" :label="$t('admin_page.payout_batch_index.payout_transaction_list_label')" :description="payoutTransactionCsvFileName" label-for="input-horizontal">
              <input @change="processPayoutTransactionBatch($event)" type="file" ref="payoutTransactionRef" class="form-control" accept=".csv, text/csv" style="display: none;" />
              <b-button @click="$refs.payoutTransactionRef.click()" variant="success" class="btn-md" :disabled="isSubmitted">{{ $t('admin_page.payout_batch_index.payout_upload_button_text') }}</b-button>
            </b-form-group>
            <div class="d-flex justify-content-center">
              <b-button type="submit" variant="primary" class="btn-md" :disabled="!payoutListCsvFile || !payoutTransactionCsvFile || isUploading" v-if="!isSubmitted">{{ $t('admin_page.payout_batch_index.submit_button_text') }}</b-button>
              <b-button v-else type="button" variant="primary" class="btn-md" @click="loadPayoutListData">{{ $t('admin_page.payout_batch_index.payout_retrieve_button_text') }}</b-button>
            </div>
          </form>
        </div>
      </div>
      <div class="col-12 mt-3" v-if="listOfPayoutDatas.length > 0 ">
        <div class="table-responsive table-bordered visitors-table">
          <table id="dataTable" cellspacing="0" class="table table-bordered visitors-table mb-0" width="100%">
            <thead>
              <tr>
                <th>{{ $t('admin_page.payout_batch_table.facility_name_table_column') }}</th>
                <th>{{ $t('admin_page.payout_batch_table.payout_date_table_column') }}</th>
                <th>{{ $t('admin_page.payout_batch_table.amount_table_column') }}</th>
                <th>{{ $t('admin_page.payout_batch_table.fee_table_column') }}</th>
                <th>{{ $t('admin_page.payout_batch_table.processing_fee_table_column') }}</th>
                <th>{{ $t('admin_page.payout_batch_table.total_table_column') }}</th>
                <th>{{ $t('admin_page.payout_batch_table.vat_table_column') }}</th>
                <th>{{ $t('admin_page.payout_batch_table.total_table_column') }} + {{ $t('admin_page.payout_batch_table.vat_table_column') }}</th>
                <th>{{ $t('admin_page.payout_batch_table.net_table_column') }}</th>
                <th>{{ $t('admin_page.payout_batch_table.list_table_column') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, key) in listOfPayoutDatas" :key="key">
                <td>{{ value.facility.name }}</td>
                <td>{{ formatDateToSlash(value.payout_date) }}</td>
                <td>{{ formatNumber(value.amount) }}</td>
                <td>{{ formatNumber(value.fee) }}</td>
                <td>{{ formatNumber(value.processing_fee) }}</td>
                <td>{{ formatNumber(value.total) }}</td>
                <td>{{ formatNumber(value.vat) }}</td>
                <td>{{ computeTotalAndVat(value.total, value.vat) }}</td>
                <td>{{ formatNumber(value.net) }}</td>
                <td>
                  <a class="btn btn-success btn-sm text-sm mr-4" role="button" @click="getPayoutTransactionListData(value.id)">{{ $t('admin_page.payout_batch_table.list_button_text') }}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-center" v-if="isSubmitted">
          <b-button type="button" variant="danger" class="btn-md mr-3" @click="deletePayoutBatch">{{ $t('admin_page.payout_batch_index.cancel_button_text') }}</b-button>
          <b-button type="button" variant="primary" class="btn-md" @click="confirmPayoutBatch">{{ $t('admin_page.payout_batch_index.payout_confirm_button_text') }}</b-button>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <div style="max-width: 400px;">
          <b-alert v-if="alert.show" :variant="alert.variant" show class="mt-3">{{ alert.message }}</b-alert>
        </div>
      </div>
    </div>
    <PayoutListDetails ref="payoutListDetails" />
    <PdfViewer v-if="invoice.src" :src="invoice.src" />
  </div>
</template>

<style scoped>
</style>
